import { dayMap } from './Calendar.constants.js';

const today = {
    year: new Date().getFullYear(),
    month: new Date().getMonth() + 1,
    date: new Date().getDate(),
    day: new Date().getDay()
};
const generateDate = (data)=>{
    const [year, month, date] = data === null || data === void 0 ? void 0 : data.split('-');
    const day = new Date(Number(year), Number(month) - 1, Number(date)).getDay();
    return {
        year: Number(year),
        month: Number(month),
        date: Number(date),
        day
    };
};
const isSameDate = (referencePoint, target)=>{
    if (typeof referencePoint === 'string') {
        const [year, month, date] = referencePoint.split('-');
        return new Date(Number(year), Number(month) - 1, Number(date)).getTime() == new Date(target.year, Number(target.month) - 1, Number(target.date)).getTime();
    }
    if (typeof referencePoint === 'object') {
        return new Date(referencePoint.year, Number(referencePoint.month) - 1, Number(referencePoint.date)).getTime() == new Date(target.year, Number(target.month) - 1, Number(target.date)).getTime();
    }
};
const getMonthDate = (year, month)=>{
    const lastDate = new Date(year, month, 0).getDate();
    const firstDay = new Date(year, month - 1, 1).getDay();
    const lastDay = new Date(year, month - 1, lastDate).getDay();
    // 날짜 변환 함수
    const dateList = new Array(lastDate).fill(null).map((_, i)=>({
            year: year,
            month: month,
            date: i + 1,
            day: new Date(year, month - 1, i + 1).getDay()
        }));
    return {
        lastDate,
        firstDay,
        lastDay,
        dateList
    };
};
const getKoreanTimeString = (createdTime)=>{
    const { year: initialYear, month: initialMonth, date: initialDate } = createdTime;
    const formattedMonth = initialMonth.toString().padStart(2, '0');
    const formattedDate = initialDate === null || initialDate === void 0 ? void 0 : initialDate.toString().padStart(2, '0');
    const newDate = new Date(`${initialYear}-${formattedMonth}-${formattedDate}`);
    const item = new Intl.DateTimeFormat('ko-KR', {
        timeZone: 'Asia/Seoul',
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        hour12: true
    }).format(newDate);
    const [year, month, date, half, time] = item.replace(/\./g, '').split(' ');
    const day = new Date(Number(year), Number(month) - 1, Number(date)).getDay();
    return {
        year: `${year}년`,
        month: `${month}월`,
        date: `${date}일`,
        time: `${half} ${time}`,
        day: dayMap.get(day)
    };
};

export { generateDate, getKoreanTimeString, getMonthDate, isSameDate, today };
